<section class="home-package">
    <div class="container">
       <div class="row">
          <div class="col-lg-8 offset-lg-2 text-sm-center">
             <div class="section-heading">
                <h5 class="sub-title">BUSCAMOS SOLUCIONES PARA TUS NECESIDADES</h5>
                <h2 class="section-title">OFERTA DE PAQUETES </h2>
                <p>Incluyen servicios específicos para facilitar tu proceso y tus planes.</p>
             </div>
          </div>
       </div>
       <div class="package-section">
         <!-- Photo by <a href="https://unsplash.com/@headwayio?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Headway</a> on <a href="https://unsplash.com/photos/black-smartphone-near-person-5QgIuuBxKwM?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
          <article class="package-item">
             <figure class="package-image" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/03c1318c-b138-426d-a6f4-de39ba9d3b00/public);"></figure>
             <div class="package-content">
                <h3>
                   <a href="package-detail.html">
                     BÁSICO
                   </a>
                </h3>
                <ul>
                   <li>* Asistencia para obtener el visado de estudiante.</li>
                   <li>* Tips para búsqueda de vuelos.</li>
                   <li>* Asistencia para contratar un seguro médico.</li>
                   <li>* Asistencia para preparar la maleta según las estaciones.</li>
                   <li></li>
                   <li style="font-weight: 900;">y más...</li>
                </ul>
           
                <div class="package-meta">
                   <ul>
                       <li>
                        <i class="fas fa-headset"></i>
                           1 Videollamada 30 min
                        </li>
                      <li>
                         <i class="fas fa-envelope"></i>
                         Vía email
                      </li>
                   </ul>
                </div>
             </div>
             <div class="package-price">
                <div class="review-area">
                   <!-- <span class="review-text">(25 reviews)</span>
                   <div class="rating-start-wrap d-inline-block">
                      <div class="rating-start">
                         <span style="width: 80%"></span>
                      </div>
                   </div> -->
                </div>
                <h6 class="price-list">
                   / desde
                   <span>$89</span>
                </h6>
                <a href="javascript: void(0)" class="outline-btn outline-btn-white" (click)="goToCalendly()">Me interesa</a>
             </div>
          </article>
          <article class="package-item">
             <figure class="package-image" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/646f38d8-cbdb-4a5a-9f4d-f9510bad9800/public);"></figure>
             <div class="package-content">
                <h3>
                   <a href="package-detail.html">
                      PREMIUM
                   </a>
                </h3>
                <ul>
                   <li>* Guía básica para encontrar alojamiento en la ciudad de elección.</li>
                   <li>* Guía para realizar un presupuesto mensual.</li>
                   <li>* Asistencia para conseguir el TIE (citas, requisitos, etc).</li>
                   <li>* Grupo de whatsapp dedicado.</li>
                   <li></li>
                   <li style="font-weight: 900;">y más...</li>

                </ul>
                <div class="package-meta">
                   <ul>
                      <li>
                        <i class="fas fa-headset"></i>
                         3 Videollamadas 30 min
                      </li>
                      <li>
                        <i class="fab fa-whatsapp"></i>
                         Whatsaap
                      </li>
                   </ul>
                </div>
             </div>
             <div class="package-price">
                <!-- <div class="review-area">
                   <span class="review-text">(12 reviews)</span>
                   <div class="rating-start-wrap d-inline-block">
                      <div class="rating-start">
                         <span style="width: 80%"></span>
                      </div>
                   </div>
                </div> -->
                <h6 class="price-list">
                   / desde
                   <span>$129</span>
                </h6>
                <a href="javascript: void(0)" class="outline-btn outline-btn-white" (click)="goToCalendly()">Me interesa</a>
             </div>
          </article>
          <!-- Photo by <a href="https://unsplash.com/@raddfilms?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Redd F</a> on <a href="https://unsplash.com/photos/people-sitting-on-chair-5U_28ojjgms?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
          <article class="package-item">
             <figure class="package-image" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/64459881-31d7-462a-0d29-cd3a46c50900/public);"></figure>
             <div class="package-content">
                <h3>
                   <a href="package-detail.html">
                      FULL ASSISTANCE
                   </a>
                </h3>
                <ul>
                  <li>* Consultoría para buscar trabajo en España (pasantías, plataformas de trabajo, requisitos)</li>
                   <li>* Guía avanzada para vivir en España (movilidad, gastronomía, cultura, lugares de interés)</li>
                   <li></li>
                   <li style="font-weight: 900;">y más...</li>
                </ul>
                <div class="package-meta">
                   <ul>
                      <li>
                        <i class="fas fa-headset"></i>
                         6 Videollamadas 30 min
                      </li>
                      <li>
                        <i class="fab fa-whatsapp"></i>
                         Whatsaap
                      </li>
                   </ul>
                </div>
             </div>
             <div class="package-price">
                
                <h6 class="price-list">
                   / desde
                   <span>$229</span>
                   
                </h6>
                <a href="javascript: void(0)" class="outline-btn outline-btn-white" (click)="goToCalendly()">Me interesa</a>
             </div>
          </article>
          <!-- <div class="section-btn-wrap text-center">
             <a href="package.html" class="round-btn">VIEW ALL PACKAGES</a>
          </div> -->
       </div>
    </div>
 </section>